import { render, staticRenderFns } from "./ControlManage.vue?vue&type=template&id=20b08422&scoped=true"
import script from "./ControlManage.vue?vue&type=script&lang=js"
export * from "./ControlManage.vue?vue&type=script&lang=js"
import style0 from "./ControlManage.vue?vue&type=style&index=0&id=20b08422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b08422",
  null
  
)

export default component.exports